import {QuantityLimitState} from "@/store/settings/quantity_limits/types";
import {Module} from "vuex";
import {RootState} from "@/store/types";
import {getters} from "@/store/settings/quantity_limits/getters";
import {mutations} from "@/store/settings/quantity_limits/mutations";
import {actions} from "@/store/settings/quantity_limits/actions";

export const state: QuantityLimitState = {
    quantityLimit:[],
}

export const quantityLimits: Module<QuantityLimitState, RootState> = {
    state,
    getters,
    mutations,
    actions
}
